'use client'
import { useState } from 'react'
import { toast, useDocumentInfo } from '@payloadcms/ui'

/**
 * Sidebar button in the Posts edit view: machine-translate the Persian post
 * into an English draft (enStatus → machine-draft). The reviewer then edits
 * under the EN locale tab and sets enStatus to "reviewed".
 */
export function TranslateButton() {
  const { id } = useDocumentInfo()
  const [busy, setBusy] = useState(false)
  const [report, setReport] = useState<string | null>(null)

  if (!id) return null

  const run = async () => {
    setBusy(true)
    setReport(null)
    try {
      const res = await fetch(`/api/posts/${id}/translate`, {
        method: 'POST',
        credentials: 'include',
      })
      const data = (await res.json()) as {
        segmentCount?: number
        linkChecklist?: { kind: string; anchorText: string; target: string }[]
        error?: string
      }
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`)
      const links = data.linkChecklist?.length ?? 0
      setReport(
        `ترجمه شد: ${data.segmentCount} قطعه متن` +
          (links > 0 ? ` — ${links} لینک نیاز به بازبینی دارد` : ''),
      )
      toast.success('English machine-draft created — review it under the EN locale.')
      // reload so the EN locale tab shows the fresh draft
      setTimeout(() => window.location.reload(), 1200)
    } catch (err) {
      toast.error(`Translation failed: ${err instanceof Error ? err.message : String(err)}`)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBlock: 12 }}>
      <button
        type="button"
        onClick={run}
        disabled={busy}
        className="btn btn--style-secondary btn--size-medium"
        style={{ cursor: busy ? 'wait' : 'pointer' }}
      >
        {busy ? 'در حال ترجمه…' : 'ترجمه به انگلیسی (پیش‌نویس)'}
      </button>
      {report && <p style={{ fontSize: 12, margin: 0 }}>{report}</p>}
    </div>
  )
}
